module.exports = __webpack_public_path__ + "static/assets/de056df8d895f6eb4e1992bc43c0c5e3.png";